export default __webpack_public_path__ + "9e08d63.png";